<div
	class="toggle-container"
	[ngClass]="['label-' + labelPosition, disabled ? 'disabled' : '']"
>
	<input
		[id]="name"
		type="checkbox"
		[(ngModel)]="value"
		[disabled]="disabled"
	/>
	<label class="toggle" [for]="name"></label>
	<p>{{ value ? 'On' : 'Off' }}</p>
</div>
